export enum AnalyticsValue {
  ProductLine = 'productLine',
  DeliveryMethod = 'deliveryMethod',
  OrderId = 'orderId',
  JobsiteId = 'jobsiteId',
  PointOfDeliveryId = 'pointOfDeliveryId',
  ProductDescription = 'productDescription',
  ProductQuantity = 'productQuantity',
  DeliveryDate = 'deliveryDate',
  DeliveryTime = 'deliveryTime',
  PaymentTerm = 'paymentTerm',
  ActiveStep = 'activeStep',
  Price = 'price',
  ProductId = 'productId',
  ProductUnit = 'productUnit',
  CleanUp = 'cleanUp',
}

export const ANALYTICS_DEFAULT_LANGUAGE = 'en_US';
export const ANALYTICS_DATE_FORMAT = 'DD-MM-YYYY';
